export default {
  canSeePlanInfo(state) {
    if (state.userPermissions && state.userPermissions.length) {
      return !state.userPermissions.includes('view-plan-denied')
    }
    return false
  },
}
